import React from 'react'

import imageLoading from "../assets/images/loading.gif";

class Loading extends React.Component{
    render() {
        return (
            <div className="logo" style={{ position: 'absolute', left: '50%', top: '20%', right: 0, transform: 'translateX(-50%)', zIndex: 999 }}>
                <img src={imageLoading} alt=""/>
            </div>
        )
    }
}

export default Loading